/**
 * Created by claudio iozzia on 29/06/2017.
 */
import {Acceptor_DcDc_Buck} from "./dcdc_buck_acceptor";
import {ISingleOutput} from "../../../../models/ISpec";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic} from "../../../../models/common";
import {Utils} from "../../../../common/utils";
import {acceptSingle_common_Vout} from "./dcdc__common_acceptor";
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";

export class Acceptor_DcDc_Buck_6902 extends Acceptor_DcDc_Buck {
  private acceptSingle_Buck_6902_Vout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {

    return  ((Utils.isValueEmpty(out.voltage)) || (Utils.isValueEmpty(spec.spec.value.input.min)) || ( out.voltage < ( spec.spec.value.input.min - 2))) ;
  }

  protected singleOutputV(): AcceptorOutputFn {return andAcceptorSingle([acceptSingle_common_Vout, this.acceptSingle_Buck_6902_Vout]); }
}
